<flx-modal-panel headerClass="py-1">
  <ng-container header>
    @if (processDefinitionName()) {
      <flx-resource-instances-autocomplete
        [processDefinitionName]="processDefinitionName()"
        (selectedInstanceChanged)="setProcessInstance($event)"
        class="grow process-instances-autocomplete"
        placeholder="Select or Type Past Process Instance"
      >
      </flx-resource-instances-autocomplete>

      <button
        [disabled]="disabledProcessInstanceLoad()"
        (click)="loadProcessInstanceData()"
        class="flx-ds small secondary"
        flxButton
      >
        Apply
      </button>
    }
  </ng-container>
  <flx-code-editor
    [options]="codeEditorOptions"
    [(ngModel)]="data"
    class="h-full"
  ></flx-code-editor>
</flx-modal-panel>
